<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <v-row>
          <v-col>
            <div class="form-base__title">
              {{ Text.refusalDetailsTitle }}
            </div>
          </v-col>
        </v-row>

        <BankDetails :v="$v.form.section1" />

        <v-row>
          <v-col cols="12">
            <v-checkbox
              v-model="$v.form.section2.hasPrivilege.$model"
              label="Наличие льготы"
            />
          </v-col>
          <v-col v-if="form.section2.hasPrivilege" cols="12">
            <div class="mb-8">
              <v-textarea
                v-model="$v.form.section2.note.$model"
                :errorMessages="getValidationErrorText($v.form.section2.note)"
                outlined
                label="Примечание (основание для льготы, при наличии)"
              />
              <p class="text-small-size">
                {{ Text.hasPrivilegeNote }}
              </p>
            </div>

            <AttachDocumentMultiple v-model="form.documents" />
          </v-col>
        </v-row>
      </div>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators';
import cloneDeep from 'clone-deep';

import { getValidationErrorText, EMOJI } from '@/utils/validate';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import AttachDocumentMultiple from '@/components/base/AttachDocument/AttachDocumentMultiple';
import { Text, checkInvalid, leaveStep } from '@/utils/services';
import { StepDirection, StepName } from '@/types/services';
import BankDetails, {
  bankDetails,
  bankDetailsValidation,
} from '@/components/services/elements/BankDetails';
import { SecuringEvidenceStep } from '@/constants';

export default {
  name: 'AccountBankDetails',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Footer,
    BankDetails,
    AttachDocumentMultiple,
  },
  validations() {
    const form = {
      section1: bankDetailsValidation,
      section2: {
        hasPrivilege: {},
        note: {
          maxLength: maxLength(4000),
          EMOJI,
        },
      },
    };

    if (this.form.section2.hasPrivilege) {
      form.section2.note = {
        required,
        maxLength: maxLength(4000),
        EMOJI,
      };
    }

    return { form };
  },
  data: () => ({
    StepDirection,
    StepName,
    leaveStep,
    Text,
    getValidationErrorText,
    invalidFields: [],
    form: {
      section1: cloneDeep(bankDetails),
      section2: {
        hasPrivilege: false,
        note: '',
      },
      documents: [],
    },
  }),
  created() {
    this.prefillDraft();
  },
  methods: {
    touchFields() {
      this.invalidFields = [];
      this.$v.form.$touch();
      checkInvalid(this.$v.form, this.invalidFields);
    },

    assemblyModel() {
      const ruzdiDetails = cloneDeep(this.form.section2);
      let documents = cloneDeep(this.form.documents);

      if (!ruzdiDetails.hasPrivilege) {
        ruzdiDetails.note = null;
        documents = [];
      }

      return {
        accountBankDetails: cloneDeep(this.form.section1),
        ruzdiDetails,
        documents,
      };
    },

    prefillDraft() {
      let ABDModelStore = {};
      let RDModelStore = {};

      if (ServicesModule.statement.accountBankDetails) {
        ABDModelStore = cloneDeep(ServicesModule.statement.accountBankDetails);
      }
      if (ServicesModule.statement.ruzdiDetails) {
        RDModelStore = cloneDeep(ServicesModule.statement.ruzdiDetails);
      }

      this.form = {
        ...cloneDeep(this.form),
        section1: {
          ...cloneDeep(this.form.section1),
          ...cloneDeep(ABDModelStore),
        },
        section2: {
          ...cloneDeep(this.form.section2),
          ...cloneDeep(RDModelStore),
        },
        documents: cloneDeep(ServicesModule.statement.documents),
      };
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: SecuringEvidenceStep.BANK_DETAILS,
      });
    },
  },
};
</script>
